var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form"}},[_c('v-card',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();}}},[_vm._t("form")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }